import { format, parse } from "date-fns";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { SelectSingleEventHandler } from "react-day-picker";
import { useState } from "react";

export function DatePicker({
  id,
  selected,
  onSelect,
}: {
  id?: string;
  selected?: string;
  onSelect: (date: Date | undefined) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const date = selected ? parse(selected, "yyyy-MM-dd", new Date()) : undefined;

  const handleOnSelect: SelectSingleEventHandler = (date) => {
    onSelect(date);
    setIsOpen(false);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          id={id}
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-normal",
            !date && "text-muted-foreground",
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "d LLLL yyyy") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleOnSelect}
          autoFocus
        />
      </PopoverContent>
    </Popover>
  );
}
